export const Lender = [
  { id:1, label:"Lender-1", value:1},
  { id:2, label:"Lender-2", value:2},
  { id:3, label:"Lender-3", value:3},
  { id:4, label:"Lender-4", value:4},
  { id:5, label:"Lender-5", value:5},
  { id:6, label:"Lender-6", value:6},
  { id:7, label:"Lender-7", value:7}
];